import { useSelector } from "react-redux";

export const useUserRoles = () => {
  return useSelector(
    state => state.RolesReducer?.userRoles ?? []
  );
};
